'use client'

import { StatsigUser } from '@statsig/react-bindings'

import { getQueryParam } from '@src/quince-site-common/src/utils/get-query-param'
import { getlbUserId } from '@src/quince-site-common/src/utils/getlb-user-id'
import isBrowser from '@src/quince-site-common/src/utils/isBrowser'

import { STATSIG_EXPERIMENTS_CONFIG } from '../../config/statsig-experiments.config'

export const getStatsigUser = () => {
  const userId = getlbUserId()
  if (!userId) return null
  const user: StatsigUser = { userID: userId, custom: getForcedBucketsForUser() }
  return user
}

const LOCALSTORAGE_FORCEBUCKET_KEY = 'statsigForcedBuckets'

// Shared helper to build forcedBuckets from a mapping of experimentName -> bucket
function buildForcedBuckets(experimentToBucket: Record<string, string | undefined>): Record<string, string[]> {
  const forcedBuckets: Record<string, string[]> = {}
  Object.entries(experimentToBucket).forEach(([experimentName, bucket]) => {
    if (bucket) {
      forcedBuckets[bucket] ??= []
      forcedBuckets[bucket].push(experimentName)
    }
  })
  return forcedBuckets
}

export const getForcedBucketsForUser = () => {
  try {
    if (!isBrowser()) return {}

    // template { experimentName: bucketName }
    const persistedForcedBuckets = JSON.parse(localStorage.getItem(LOCALSTORAGE_FORCEBUCKET_KEY) ?? '{}') as Record<
      string,
      string
    >

    const experimentToBucket: Record<string, string | undefined> = {}
    const persistedValues: Record<string, string> = {}

    Object.values(STATSIG_EXPERIMENTS_CONFIG).forEach(experimentConfig => {
      let bucket = getQueryParam(experimentConfig.experimentName)
      bucket ??= persistedForcedBuckets[experimentConfig.experimentName]
      if (bucket) {
        persistedValues[experimentConfig.experimentName] = bucket
        experimentToBucket[experimentConfig.experimentName] = bucket
      }
    })

    localStorage.setItem(LOCALSTORAGE_FORCEBUCKET_KEY, JSON.stringify(persistedValues))
    return buildForcedBuckets(experimentToBucket)
  } catch (error) {
    console.error(error)
    return {}
  }
}

// SSR version: get forced buckets from query string only (no localStorage or window)
export function getServerSideStatsigForcedBuckets(queryString: string): Record<string, string[]> {
  const params = new URLSearchParams(queryString.startsWith('?') ? queryString : `?${queryString}`)
  const experimentToBucket: Record<string, string | undefined> = {}
  Object.values(STATSIG_EXPERIMENTS_CONFIG).forEach(experimentConfig => {
    const experimentName = experimentConfig.experimentName
    const bucket = params.get(experimentName)
    if (bucket) {
      experimentToBucket[experimentName] = bucket
    }
  })
  return buildForcedBuckets(experimentToBucket)
}
